// access-control.guard.ts
import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router'
import { AuthService } from './auth.service'
import { environment } from '../../environments/environment'
import { NavigationService } from '../core/navigation/navigation.service'

@Injectable({
  providedIn: 'root',
})
export class AccessControlGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private nav: NavigationService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const requiredPage = route.data['requiredPage']

    if (!requiredPage) {
      if (!environment.production) {
        console.error('Route missing requiredPage data')
      }
      return this.deny()
    }

    if (await this.auth.hasPageAccess(requiredPage)) {
      return true
    }

    return this.deny()
  }

  /**
   * Returning a bare `false` left the admin staring at the page they were already
   * on with no indication anything had happened — a denied menu click looked like
   * a broken link. Send them somewhere they can actually reach instead.
   */
  private deny(): UrlTree {
    const fallback = this.nav.visibleLeaves[0]
    return this.router.createUrlTree([fallback ? fallback.route : '/auth/login'])
  }
}
